import React from 'react';

import classes from './SearchPageSort.module.scss';

const SearchPageSort = ({ sort, sortHandler }) => {
	const changeHandler = (e) => {
		sortHandler(e.target.value);
	};
	return (
		<div className={`${classes['search-page-sort']}`}>
			<h3> Sort By:</h3>
			<div>
				<input
					type="radio"
					id="release_date"
					name="ordering"
					value="release_date"
					onChange={changeHandler}
					checked={sort === 'release_date'}
				/>
				<label htmlFor="release_date">Date of release</label>
			</div>
			<div>
				<input
					type="radio"
					id="participants_count"
					name="ordering"
					value="participants_count"
					onChange={changeHandler}
					checked={sort === 'participants_count'}
				/>
				<label htmlFor="participants_count">Number of participants</label>
			</div>
			<div>
				<input
					type="radio"
					id="title_asc"
					name="ordering"
					value="title_asc"
					onChange={changeHandler}
					checked={sort === 'title_asc'}
				/>
				<label htmlFor="title_asc">Alphabetical A - Z</label>
			</div>
			<div>
				<input
					type="radio"
					id="title_desc"
					name="ordering"
					value="title_desc"
					onChange={changeHandler}
					checked={sort === 'title_desc'}
				/>
				<label htmlFor="title_desc">Alphabetical Z - A</label>
			</div>
		</div>
	);
};

export default React.memo(SearchPageSort);
